import { faTags } from '@fortawesome/free-solid-svg-icons';
import * as Sentry from '@sentry/browser';
import { SentryTag } from '@/models';

export default class SentryService {
  logMessage(message: any, action: string = '') {
    if (message) {
      Sentry.captureMessage(
        `Log-Action: ${action}, Message: ${JSON.stringify(message)}`,
      );
    }
  }

  logException(message: any, action: string = '', tags: SentryTag = null) {
    if (message) {
      if (tags.BookingId) Sentry.setTag('BookingId', tags.BookingId);
      if (tags.BillToCustomerDescription) Sentry.setTag('BillToCustomerDescription', tags.BillToCustomerDescription);
      if (tags.Status) Sentry.setTag('Status', tags.Status);
      if (tags.TransactionType) Sentry.setTag('TransactionType', tags.TransactionType);
      if (tags.StartDate) Sentry.setTag('StartDate', tags.StartDate);
      if (tags.EndDate) Sentry.setTag('EndDate', tags.EndDate);
      if (tags.Error) Sentry.setTag('Error', tags.Error);
      if (tags.message) Sentry.setTag('message', tags.message);

      Sentry.captureException(
        Error(`Log-Action: ${action}, Message: ${JSON.stringify(message)}`),
      );
    }
  }
}
